import React from 'react';

const SignupsTable = ({ signups, onUpdateStatus, onDelete }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (signups.length === 0) {
    return (
      <div className="text-center py-12" data-testid="no-signups">
        <p className="text-muted-foreground text-lg">No signups yet.</p>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="data-table" data-testid="signups-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>City</th>
            <th>Preferred Time</th>
            <th>Status</th>
            <th>Signed Up</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {signups.map((signup) => (
            <tr key={signup.id} data-testid={`signup-row-${signup.id}`}>
              <td className="font-medium">{signup.name}</td>
              <td>{signup.email}</td>
              <td>{signup.phone}</td>
              <td>{signup.city}</td>
              <td>{signup.preferred_date_time}</td>
              <td>
                <select
                  value={signup.status}
                  onChange={(e) => onUpdateStatus(signup.id, e.target.value)}
                  className={`status-badge status-${signup.status} cursor-pointer`}
                  data-testid={`status-select-${signup.id}`}
                >
                  <option value="confirmed">Confirmed</option>
                  <option value="waitlist">Waitlist</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </td>
              <td className="text-sm text-muted-foreground">
                {formatDate(signup.created_at)}
              </td>
              <td>
                <button
                  onClick={() => onDelete(signup.id)}
                  className="text-sm text-destructive hover:underline"
                  data-testid={`delete-btn-${signup.id}`}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SignupsTable;